export const FACILITY_TABLE_COLUMN_CLASS = {
  name: "tw-w-[36%] tw-min-w-[12rem]",
  type: "tw-w-[26%] tw-min-w-[9rem]",
  ownership: "tw-w-[18%] tw-min-w-[7rem]",
  actions: "tw-w-[20%] tw-min-w-[7rem]"
} as const;

export type FacilityColumnKey = Exclude<keyof typeof FACILITY_TABLE_COLUMN_CLASS, "actions">;

export const FACILITY_TABLE_COLUMNS: ReadonlyArray<{ key: FacilityColumnKey; label: string }> = [
  { key: "name", label: "Facility Name" },
  { key: "type", label: "Facility Type" },
  { key: "ownership", label: "Ownership" }
];

export const ROW_SKELETON_COUNT = 5;
export const COLUMN_COUNT = FACILITY_TABLE_COLUMNS.length + 1;
